/**
 * Utilitário centralizado para regras de janela 24h do Instagram
 * 
 * Regra de negócio:
 * - Comentários do Instagram NÃO abrem/renovam a janela de 24h
 * - Apenas DMs e Stories contam para a janela de 24h
 * - Este módulo centraliza a verificação para evitar divergências
 * 
 * @release v1.0.0 - 2026-03-24
 */

/**
 * Interface mínima de mensagem para verificação de elegibilidade
 * Compatível com os tipos Message de Chat.tsx e useChatConversation.ts
 */
interface SessionWindowMessage {
  message_type?: string | null;
  metadata?: { source?: string; [key: string]: unknown } | null;
}

/**
 * Verifica se uma mensagem inbound é elegível para atualizar a janela de 24h
 * 
 * Retorna FALSE para comentários do Instagram (não contam para janela 24h)
 * Retorna TRUE para DMs, stories e qualquer outra mensagem inbound
 * 
 * @param message - Mensagem com message_type e metadata
 * @returns true se a mensagem deve atualizar last_inbound_at
 */
export function isEligibleForSessionWindow(message: SessionWindowMessage): boolean {
  // Comentários do Instagram NÃO são elegíveis para janela 24h
  const isComment = 
    message.message_type === 'comment' ||
    (message.metadata as { source?: string })?.source === 'instagram-comment';

  return !isComment;
}
